import { ReactNode } from "react";

export interface NotificationProviderProps {
  children: ReactNode;
}

export interface NotificationProps{
  showNotification:() => void
}

export enum NotificationTypeEnum {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}

export interface NotificationOptionalParams{
  duration?: number,
  onClose?: any
}